<template>
  <v-main>
    <!-- Left navigation panel -->
    <users />
    <div class="pb-4" fill-height>
      <buddies />
    </div>
  </v-main>
</template>

<script>
import Users from '@/components/users'
import Buddies from '@/components/buddies'
export default {
  name: 'view-users',
  components: { Users, Buddies }
}
</script>

<style scoped>
</style>
